// extracted by mini-css-extract-plugin
export var loadingSpinner = "_5x-1";
export var standaloneTable = "_5x-0";